import Panel from './panel';
import Form from './form';
import Item from './form/item';
import Icon from './icon';
import Text from './text';
import Image from './image';
import Button from './button';
import Switch from './switch';
import Radio from './radio';
import RadioGroup from './radio/group';
import Checkbox from './checkbox';
import CheckboxGroup from './checkbox/group';
import Input from './input';
import Popover from './popover';
import Select from './popover/select';
import SelectSearch from './popover/select/search';
import Tabs from './tabs';
import Table from './table';
import TableColumn from './table/column';
import TableRadio from './table/radio';
import TableCheckbox from './table/checkbox';
import Pagination from './pagination';
import PaginationPager from './pagination/pager';
import Editor from './editor';
import EditorLink from './editor/link';
import EditorImage from './editor/image';
import Modal from './modal';
import Dialog from './modal/dialog';
import Message from './modal/message';

/**
 * 扩展组件库
 */
export default {
	Panel,
	Form,
	Item,
	Icon,
	Text,
	Image,
	Button,
	Switch,
	Radio,
	RadioGroup,
	Checkbox,
	CheckboxGroup,
	Input,
	Popover,
	Select,
	SelectSearch,
	Tabs,
	Table,
	TableColumn,
	TableRadio,
	TableCheckbox,
	Pagination,
	PaginationPager,
	Editor,
	EditorLink,
	EditorImage,
	Modal,
	Dialog,
	Message,
	install(Vue, config = {}) {

		/**
		 * 初始化全局组件
		 */
		Object.entries(this).forEach(([k, v]) => {
			let Component = Vue.extend(Object.assign({ props: {} }, v));
			Component.prototype._config = config[k] || {};
			k == 'install' || Vue.component(`V${k}`, Component)
		});

		/**
		 * 对话框
		 * @param {Object} options 对话框选项
		 * @param {Function} cb 按钮功能回调
		 */
		Vue.prototype.$dialog = Vue.ext.dialog = Object.assign(function (options) {
			options = Object.assign({
				title: '',
				message: '',
				buttons: []
			}, options);
			let vm = new Vue({
				el: document.createElement('div'),
				mounted() {
					this.$refs.dialog.open();
				},
				data: {
					resloves: [],
					rejects: []
				},
				render($) {
					return $('v-dialog', {
						ref: 'dialog',
						props: { title: options.title }
					}, [
							options.message,
							$('div', {
								slot: 'foot',
								style: { textAlign: 'right' },
							}, options.buttons.map((b, i) => {
								if (typeof b == 'string') b = { text: b };
								return $('v-button', {
									attrs: { type: b.type },
									on: {
										click() {
											function close() { vm.$refs.dialog.close() }
											let cbs = [
												vm.resloves,
												vm.rejects
											][i];
											if (cbs.length) {
												cbs.reduce((p, r) => [r.apply(r, p)], [close]);
											} else {
												close();
											}
										}
									}
								}, b.text)
							}).reduce((p, o) => {
								return p.push(o, ' '), p;
							}, []))
						]
					);
				}
			});
			return {
				then(reslove, reject) {
					if (reslove) vm.resloves.push(reslove);
					if (reject) vm.rejects.push(reject);
					return this;
				},
				catch(rejected) {
					if (rejected) vm.rejects.push(rejected);
				}
			}
		}, {
				alert(message, title = '提示') {
					return Vue.prototype.$dialog({
						title, message,
						buttons: [{ text: '确认', type: 'primary' }]
					})
				},
				confirm(message, title = '提示') {
					return Vue.prototype.$dialog({
						title, message,
						buttons: [{ text: '确认', type: 'primary' }, '取消']
					})
				}
			});

		/**
		 * 消息弹窗
		 * @param {string} message 消息内容
		 * @param {number} duration 持续时长
		 * @param {string} type 消息类型
		 */
		Vue.prototype.$message = Vue.ext.message = Object.assign(function (message, duration = 3000, type = 'info') {
			if (typeof duration == 'string') type = duration, duration = 3000;
			return new Promise(reslove => {
				new Vue({
					el: document.createElement('div'),
					mounted() {
						this.$refs.message.open();
						if (duration > 0) {
							this.$timeout(() => {
								this.$refs.message.close();
								reslove();
							}, duration);
						} else {
							reslove(() => this.$refs.message.close());
						}
					},
					render($) {
						return $('v-message', {
							ref: 'message',
							props: { type },
							attrs: { closable: duration ? null : '' }
						}, [message]);
					}
				});
			});
		}, {
				info: (m, d) => Vue.ext.message(m, d, 'info'),
				warn: (m, d) => Vue.ext.message(m, d, 'warn'),
				error: (m, d) => Vue.ext.message(m, d, 'error'),
				success: (m, d) => Vue.ext.message(m, d, 'success'),
			});

	}
}


// WEBPACK FOOTER //
// ./src/vue-ext/components/index.js